import { z } from 'zod';


export const emailSchema = z.object({
    email: z.string().min(1, 'Email is required').pipe(z.email('Invalid email')),
});

export type EmailFormData = z.infer<typeof emailSchema>;
